import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "content-container order-content" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_base_loader = _resolveComponent("base-loader")!
  const _component_base_panel = _resolveComponent("base-panel")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "page-wrapper" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: "ionic-header ion-no-border",
        mode: "ios",
        "no-border": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, {
            class: "toolbar",
            mode: "ios",
            "no-padding": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    icon: _ctx.BackIcon,
                    "default-href": "/",
                    text: ""
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("svg", {
                        class: "icon",
                        fill: "none",
                        height: "24",
                        viewBox: "0 0 24 24",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z",
                          fill: "black"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "title" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Online Bankieren ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-content-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("main", _hoisted_1, [
            _createVNode(_component_base_panel, { class: "qr-panel" }, {
              content: _withCtx(() => [
                _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "heading" }, " Scan de QR code ", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("p", null, " Wacht tot de klant betaald heeft. Als dit gelukt is, kom je op de volgende pagina. ", -1)),
                _createVNode(_Transition, {
                  name: "qr-fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_ctx.order.QRCodeURL && !_ctx.loadingQRCode)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.order.QRCodeURL.src,
                          alt: "QRCODE"
                        }, null, 8, _hoisted_2))
                      : (_openBlock(), _createBlock(_component_base_loader, {
                          key: 1,
                          class: "qr-loader"
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}